import {
  IconAlertTriangle,
  IconCheck,
  IconHourglass,
  IconX,
} from "@tabler/icons-react"
import { CertificateRequestStatus } from "@tfg/db/browser"
import { BadgeVariant } from "@tfg/ui"
import { useTranslation } from "react-i18next"

export function useGetCertificateRequestStatus(
  certificateRequestStatus: CertificateRequestStatus,
  userType: "brand" | "supplier",
  displayMode: "default" | "lifecycle" = "default"
) {
  const { t } = useTranslation(["certificates", "traceability"])

  switch (certificateRequestStatus) {
    case CertificateRequestStatus.SUBMITTED:
      return {
        variant: BadgeVariant.WARNING,
        icon: <IconAlertTriangle size={16} />,
        translation:
          userType === "brand"
            ? displayMode === "lifecycle"
              ? t("certificates:certificateRequestStatusLifecycle.SUBMITTED")
              : t("certificates:certificateRequestStatus.SUBMITTED")
            : t("traceability:certificateRequestStatus.SUBMITTED"),
      }
    case CertificateRequestStatus.ACCEPTED:
      return {
        variant: BadgeVariant.SUCCESS,
        icon: <IconCheck size={16} />,
        translation:
          userType === "brand"
            ? displayMode === "lifecycle"
              ? t("certificates:certificateRequestStatusLifecycle.ACCEPTED")
              : t("certificates:certificateRequestStatus.ACCEPTED")
            : t("traceability:certificateRequestStatus.ACCEPTED"),
      }
    case CertificateRequestStatus.REJECTED:
      return {
        variant: BadgeVariant.ERROR,
        icon: <IconX size={16} />,
        translation:
          userType === "brand"
            ? t("certificates:certificateRequestStatus.REJECTED")
            : t("traceability:certificateRequestStatus.REJECTED"),
      }
    case CertificateRequestStatus.OPENED:
      return {
        variant: BadgeVariant.INFO,
        icon: <IconHourglass size={16} />,
        translation:
          userType === "brand"
            ? t("certificates:certificateRequestStatus.OPENED")
            : t("traceability:certificateRequestStatus.OPENED"),
      }
    default:
      return null
  }
}
